export interface AuditActionLabel {
  label: string;
  category: string;
}

export const AUDIT_ACTION_LABELS: Record<string, AuditActionLabel> = {
  USER_LOGIN: { label: 'Fez login no sistema', category: 'Autenticação' },
  PASSWORD_CHANGED: { label: 'Alterou a própria senha', category: 'Autenticação' },
  USER_PERMISSION_CHANGED: { label: 'Alterou permissão de usuário', category: 'Usuário' },
  USER_CREATED: { label: 'Cadastrou novo usuário', category: 'Usuário' },
  USER_DELETED: { label: 'Removeu usuário', category: 'Usuário' },
  USER_REGISTRATION_ACCEPTED: { label: 'Aceitou registro de usuário', category: 'Usuário' },
  ACCOUNT_CLOSED: { label: 'Fechou a própria conta', category: 'Usuário' },
  PASSWORD_RESET_REQUESTED: { label: 'Solicitou redefinição de senha', category: 'Autenticação' },
  PASSWORD_RESET_COMPLETED: { label: 'Redefiniu a senha', category: 'Autenticação' },
  LIVE_SCHEDULE_CREATED: { label: 'Agendou transmissão ao vivo', category: 'Transmissão' },
  LIVE_SCHEDULE_UPDATED: { label: 'Editou agendamento de transmissão', category: 'Transmissão' },
  LIVE_SCHEDULE_DELETED: { label: 'Removeu agendamento de transmissão', category: 'Transmissão' },
  LIVE_CREATED: { label: 'Criou transmissão ao vivo', category: 'Transmissão' },
  LIVE_UPDATED: { label: 'Editou transmissão ao vivo', category: 'Transmissão' },
  LIVE_CONFIG_UPDATED: { label: 'Alterou configuração da transmissão', category: 'Transmissão' },
  LIVE_PLAYLIST_UPDATED: { label: 'Atualizou playlist da transmissão', category: 'Transmissão' },
  LIVE_MEDIA_CREATED: { label: 'Adicionou mídia à transmissão', category: 'Transmissão' },
  LIVE_MEDIA_UPDATED: { label: 'Editou mídia da transmissão', category: 'Transmissão' },
  LIVE_MEDIA_DELETED: { label: 'Removeu mídia da transmissão', category: 'Transmissão' },
  LIVE_SCOREBOARD_LINK_GENERATED: { label: 'Gerou link do placar', category: 'Transmissão' },
  LIVE_REALTIME_REFRESHED: { label: 'Atualizou transmissão em tempo real', category: 'Transmissão' },
  LIVE_EMAIL_ADDED: { label: 'Adicionou e-mail de notificação', category: 'Transmissão' },
  LIVE_EMAIL_REMOVED: { label: 'Removeu e-mail de notificação', category: 'Transmissão' },
  LIVE_DROPLET_TOGGLED: { label: 'Alternou droplet da transmissão', category: 'Transmissão' },
  LIVE_DROPLET_RESTARTED: { label: 'Reiniciou droplet da transmissão', category: 'Transmissão' },
  LIVE_PAYMENT_SYNCED: { label: 'Sincronizou pagamento da transmissão', category: 'Transmissão' },
  CHANNEL_LOGO_UPLOADED: { label: 'Enviou logo do canal', category: 'Canal' },
  CHANNEL_LOGO_UPDATED: { label: 'Atualizou logo do canal', category: 'Canal' },
  CHANNEL_LOGO_REMOVED: { label: 'Removeu logo do canal', category: 'Canal' },
  CHANNEL_UPDATED: { label: 'Editou canal', category: 'Canal' },
  CHANNEL_DELETED: { label: 'Removeu canal', category: 'Canal' },
  CHANNEL_STATUS_CHANGED: { label: 'Alterou status do canal', category: 'Canal' },
  YOUTUBE_CONNECTED: { label: 'Conectou conta do YouTube', category: 'Canal' },
  YOUTUBE_DISCONNECTED: { label: 'Desconectou conta do YouTube', category: 'Canal' },
  ESTABLISHMENT_CREATED: { label: 'Cadastrou estabelecimento', category: 'Estabelecimento' },
  ESTABLISHMENT_UPDATED: { label: 'Editou estabelecimento', category: 'Estabelecimento' },
  ESTABLISHMENT_DELETED: { label: 'Removeu estabelecimento', category: 'Estabelecimento' },
  ESTABLISHMENT_STATUS_CHANGED: { label: 'Alterou status do estabelecimento', category: 'Estabelecimento' },
  ESTABLISHMENT_HASH_CREATED: { label: 'Gerou link de convite', category: 'Estabelecimento' },
  ESTABLISHMENT_HASH_DELETED: { label: 'Removeu link de convite', category: 'Estabelecimento' },
  CHECKOUT_CREATED: { label: 'Criou checkout de pagamento', category: 'Pagamento' },
  SUBSCRIPTION_CANCELED: { label: 'Cancelou assinatura', category: 'Pagamento' },
  PAYMENT_WEBHOOK_PROCESSED: { label: 'Processou webhook de pagamento', category: 'Pagamento' },
  PAYMENT_SYNCED: { label: 'Sincronizou pagamento', category: 'Pagamento' },
  PLAYLIST_CREATED: { label: 'Criou playlist', category: 'Playlist' },
  PLAYLIST_UPDATED: { label: 'Editou playlist', category: 'Playlist' },
  PLAYLIST_DELETED: { label: 'Removeu playlist', category: 'Playlist' },
  SCOREBOARD_CONFIG_UPDATED: { label: 'Alterou configuração do placar', category: 'Placar' },
  VISITOR_CREATED: { label: 'Cadastrou visitante', category: 'Visitante' },
  VISITOR_UPDATED: { label: 'Editou visitante', category: 'Visitante' },
  VISITOR_DELETED: { label: 'Removeu visitante', category: 'Visitante' },
  VISITOR_PASSWORD_CHANGED: { label: 'Alterou senha do visitante', category: 'Visitante' },
  VISITOR_FOLLOWED: { label: 'Seguiu visitante', category: 'Visitante' },
  VISITOR_UNFOLLOWED: { label: 'Deixou de seguir visitante', category: 'Visitante' },
  ACCEPTANCE_CREATED: { label: 'Aceitou termo de uso', category: 'Termo' },
  TERM_CREATED: { label: 'Criou termo de uso', category: 'Termo' },
  VIDEO_DELETED: { label: 'Removeu vídeo', category: 'Vídeo' },
  VIDEO_RESTORED: { label: 'Restaurou vídeo', category: 'Vídeo' },
  VIDEO_STATUS_UPDATED: { label: 'Alterou status do vídeo', category: 'Vídeo' },
  VIDEO_LIKED: { label: 'Curtiu vídeo', category: 'Vídeo' },
  MEDIA_CREATED: { label: 'Adicionou mídia', category: 'Mídia' },
  MEDIA_DELETED: { label: 'Removeu mídia', category: 'Mídia' },
  FAVORITE_CREATED: { label: 'Adicionou aos favoritos', category: 'Favorito' },
  FAVORITE_DELETED: { label: 'Removeu dos favoritos', category: 'Favorito' },
  SAVED_VIDEO_CREATED: { label: 'Salvou vídeo', category: 'Favorito' },
  SAVED_VIDEO_DELETED: { label: 'Removeu vídeo salvo', category: 'Favorito' },
  NEWSLETTER_SUBSCRIBED: { label: 'Inscreveu na newsletter', category: 'Newsletter' },
  NEWSLETTER_UNSUBSCRIBED: { label: 'Cancelou inscrição na newsletter', category: 'Newsletter' },
  GOALKEEPER_CREATED: { label: 'Cadastrou goleiro', category: 'Goleiro' },
  GOALKEEPER_UPDATED: { label: 'Editou goleiro', category: 'Goleiro' },
  GOALKEEPER_DELETED: { label: 'Removeu goleiro', category: 'Goleiro' },
  GOALKEEPER_PHOTO_UPDATED: { label: 'Atualizou foto do goleiro', category: 'Goleiro' },
  GOALKEEPER_PHOTO_DELETED: { label: 'Removeu foto do goleiro', category: 'Goleiro' },
  GOALKEEPER_MATCH_CREATED: { label: 'Criou partida de goleiro', category: 'Goleiro' },
  GOALKEEPER_MATCH_UPDATED: { label: 'Editou partida de goleiro', category: 'Goleiro' },
  GOALKEEPER_MATCH_CANCELED: { label: 'Cancelou partida de goleiro', category: 'Goleiro' },
  GOALKEEPER_MATCH_REQUEST_CREATED: { label: 'Solicitou participação em partida', category: 'Goleiro' },
  GOALKEEPER_MATCH_REQUEST_CANCELED: { label: 'Cancelou solicitação de partida', category: 'Goleiro' },
  GOALKEEPER_MATCH_REQUEST_RESPONDED: { label: 'Respondeu solicitação de partida', category: 'Goleiro' },
  GOALKEEPER_PARTICIPATION_CANCELED: { label: 'Cancelou participação em partida', category: 'Goleiro' },
  GOALKEEPER_REVIEW_CREATED: { label: 'Avaliou goleiro', category: 'Goleiro' },
  GOALKEEPER_REVIEW_SKIPPED: { label: 'Pulou avaliação de goleiro', category: 'Goleiro' },
  GOALKEEPER_NO_SHOW_MARKED: { label: 'Marcou não comparecimento do goleiro', category: 'Goleiro' },
  OWNER_NO_SHOW_MARKED: { label: 'Marcou não comparecimento do organizador', category: 'Goleiro' },
  PLAY_MATCH_CREATED: { label: 'Criou partida', category: 'Partida' },
  PLAY_MATCH_UPDATED: { label: 'Editou partida', category: 'Partida' },
  PLAY_MATCH_CANCELED: { label: 'Cancelou partida', category: 'Partida' },
  PLAY_MATCH_LOCKED: { label: 'Travou partida', category: 'Partida' },
  PLAY_MATCH_CLOSED: { label: 'Encerrou partida', category: 'Partida' },
  PLAY_MATCH_SLOTS_UPDATED: { label: 'Alterou vagas da partida', category: 'Partida' },
  PLAY_MATCH_REQUEST_CREATED: { label: 'Solicitou participar de partida', category: 'Partida' },
  PLAY_MATCH_REQUEST_RESPONDED: { label: 'Respondeu solicitação de partida', category: 'Partida' },
  PLAY_MATCH_REQUEST_CANCELED: { label: 'Cancelou solicitação de partida', category: 'Partida' },
  PLAY_MATCH_REVIEW_CREATED: { label: 'Avaliou partida', category: 'Partida' },
  PLAYER_NO_SHOW_MARKED: { label: 'Marcou não comparecimento de jogador', category: 'Partida' },
  NOTIFICATION_STATUS_UPDATED: { label: 'Alterou status de notificação', category: 'Notificação' },
  VERIFICATION_CODE_CREATED: { label: 'Gerou código de verificação', category: 'Autenticação' },
};

export const AUDIT_CATEGORIES = [
  { value: '', label: 'Todas as categorias' },
  { value: 'Autenticação', label: 'Autenticação' },
  { value: 'Usuário', label: 'Usuário' },
  { value: 'Transmissão', label: 'Transmissão ao vivo' },
  { value: 'Canal', label: 'Canal' },
  { value: 'Estabelecimento', label: 'Estabelecimento' },
  { value: 'Pagamento', label: 'Pagamento' },
  { value: 'Playlist', label: 'Playlist' },
  { value: 'Placar', label: 'Placar' },
  { value: 'Visitante', label: 'Visitante' },
  { value: 'Termo', label: 'Termo' },
  { value: 'Vídeo', label: 'Vídeo' },
  { value: 'Mídia', label: 'Mídia' },
  { value: 'Favorito', label: 'Favorito' },
  { value: 'Newsletter', label: 'Newsletter' },
  { value: 'Goleiro', label: 'Goleiro' },
  { value: 'Partida', label: 'Partida' },
  { value: 'Notificação', label: 'Notificação' },
];

export function getActionsByCategory(category: string): { value: string; label: string }[] {
  return Object.entries(AUDIT_ACTION_LABELS)
    .filter(([, v]) => v.category === category)
    .map(([key, v]) => ({ value: key, label: v.label }));
}
